"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExemplaryLibraries = exports.getCollectionDetails = exports.getFilters = exports.getSearch = void 0;
const shortid_1 = __importDefault(require("shortid"));
const config_1 = require("../../../shared/config/config");
const BaseRequest_1 = __importDefault(require("../../../shared/http-requests/BaseRequest"));
const ServiceBaseUrl = `${config_1.API_URL}/accessibility`;
const getSearch = (search_text, accessibleTitleSearch, cancelToken) => {
    const search_id = shortid_1.default.generate();
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}/search`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
        params: {
            search_id,
            search_text,
            accessibleTitleSearch,
        },
    });
};
exports.getSearch = getSearch;
const getFilters = (cancelToken) => {
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}/filters`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
    });
};
exports.getFilters = getFilters;
const getCollectionDetails = (codAcervo, codBiblioteca = null, cancelToken) => {
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}/collection/${codAcervo}/details`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
        params: {
            codBiblioteca,
        },
    });
};
exports.getCollectionDetails = getCollectionDetails;
const getExemplaryLibraries = (codAcervo, cancelToken) => {
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}/collection/${codAcervo}/libraries`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
    });
};
exports.getExemplaryLibraries = getExemplaryLibraries;
